import { AreaItem } from '@/types/cms/AreaItem'
import styles from './MenuHeaderTabNavigation.module.scss'
import { Link } from '@/components/Link'
import React from 'react'
import AppContext from '@/types/context'
import SidebarTrigger from '@/components/Sidebar/Trigger/SidebarTrigger'

type MenuHeaderTabNavigationProps = {
  item: AreaItem
  context: AppContext
}

const MenuHeaderTabNavigation = ({ item, context }: MenuHeaderTabNavigationProps) => {
  if (!item.model?.menu || !Array.isArray(item.model.menu) || item.model.menu.length === 0) {
    console.warn('MenuHeaderTabNavigation: No menu found in item model', item)
    return null
  }

  const highlights = (item.model.menu?.filter((menuItem: any) => menuItem.type === 'space') || [])[0] ?? []
  const quickLinks = (item.model.menu?.filter((menuItem: any) => menuItem.type === 'space') || [])[1] ?? []

  const renderLinks = (children: Array<any>, limit: number) => {
    return (
      <>
        {children
          .filter((item) => ['section', 'link'].includes(item.type))
          .slice(0, limit)
          .map((link, index) => (
            <Link href={link.url} key={index} className={styles.tab} target={link.target}>
              {link.title}
            </Link>
          ))}
      </>
    )
  }

  return (
    <div className={styles.navigation}>
      <nav className={styles.container}>
        {!context.webview && (
          <SidebarTrigger
            id="widget-menu-tab-navigation-sidebar-trigger"
            sidebarId="main"
            className={styles['sidebar-trigger']}
          />
        )}
        {highlights.children?.length > 0 && (
          <div className={styles['highlights-container']}>{renderLinks(highlights.children || [], 2)}</div>
        )}
        {quickLinks.children?.length > 0 && (
          <div className={styles['quick-container']}>{renderLinks(quickLinks.children || [], 6)}</div>
        )}
      </nav>
    </div>
  )
}

export default MenuHeaderTabNavigation
